import { HFlow, Modal, ModalBody, ModalFooter, ModalHeader, ModalProps, Text, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { getFirstGraphqlError } from 'components/error'
import { FooterButton } from 'components/footer-button'
import { information } from 'components/modals/information'
import { useInativarAtendimentoMutation } from 'graphql/hooks.generated'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'

import { TIPOS_ATENDIMENTO_RETIFICAVEIS_RNDS } from '../util-retificacaoAtendimento'
import { removerRegistroTitleMessage } from '../util-retificacaoMessages'

interface RemoveRegistroConfirmModalProps extends ModalProps {
  atendimentoProfissionalId: ID
  historicoCabecalhoId: ID
  justificativa: string
  onCancelar?(): void
  onConfirmar?(): void
  nomeCidadao: string
  tipoAtendimentoProfissional: TipoAtendimentoProfissional
  descricaoRegistrosRemovidos?: string
}

export function RemoveRegistroConfirmModal(props: Readonly<RemoveRegistroConfirmModalProps>) {
  const {
    onCancelar,
    onConfirmar,
    atendimentoProfissionalId,
    historicoCabecalhoId,
    justificativa,
    nomeCidadao,
    tipoAtendimentoProfissional,
    descricaoRegistrosRemovidos,
    ...rest
  } = props

  const alert = useAlert()

  const [inativarAtendimento, { loading }] = useInativarAtendimentoMutation()
  const tipoAtendimentoEnviaRnds = TIPOS_ATENDIMENTO_RETIFICAVEIS_RNDS.has(tipoAtendimentoProfissional)

  const handleConfirmar = async () => {
    try {
      // TODO(RNG) #23435: Inativação do atendimento individual
      await inativarAtendimento({
        variables: {
          input: {
            atendimentoProfissionalId,
            historicoCabecalhoId,
            justificativa,
          },
        },
      })

      onConfirmar?.()
      alert('success', 'Registro removido com sucesso.')
    } catch (error) {
      const errorString =
        getFirstGraphqlError(error)?.message ?? 'Ocorreu um erro não identificado ao remover o atendimento.'

      information({
        title: 'Erro ao remover atendimento',
        body: errorString,
        type: 'danger',
        depthLevel: 3,
      })()
    }
  }

  return (
    <Modal size='small' onClose={onCancelar} depthLevel={2} {...rest}>
      <ModalHeader
        title={removerRegistroTitleMessage(tipoAtendimentoProfissional, nomeCidadao)}
        icon={{ name: 'exclamationTriangleOutline', fill: 'danger' }}
      />
      <ModalBody>
        <VFlow>
          <Text>
            Todos os registros adicionados, editados e removidos da retificação serão enviados para a base nacional
            {tipoAtendimentoEnviaRnds && ' e para a RNDS'}.{' '}
            <strong>Os registros removidos poderão ser visualizados na Trilha de Auditoria do PEC e-SUS APS.</strong>
          </Text>
          {descricaoRegistrosRemovidos && tipoAtendimentoProfissional === TipoAtendimentoProfissional.VACINACAO && (
            <VFlow vSpacing={0}>
              <Text fontWeight='bold'>Registros que serão removidos:</Text>
              <Text>{descricaoRegistrosRemovidos}</Text>
            </VFlow>
          )}
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <FooterButton kind='normal' onClick={onCancelar} size='medium'>
            Cancelar
          </FooterButton>
          <FooterButton kind='danger' onClick={handleConfirmar} size='medium' disabled={loading}>
            Remover
          </FooterButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
